import React from "react";
import { observer, inject } from "mobx-react";
import loadable from "@loadable/component";
import { Banner, BannerFrame } from "ComponentsUI/Banner";
import BusinessBenefitsContainer from "Containers/BusinessBenefitsContainer";
import images from "Configs/images.config";
import { replaceStaticHost } from "Helpers/ImageManager";
import AddressPopupHOC from "HOC/AddressPopupHOC";

const AddressSearchHomeContainerB = loadable(
	() => import("Containers/AddressSearchHomeContainerB")
);

@inject("ApplicationModel")
@observer
export default class BusinessBannerContainer extends React.Component {
	render() {
		let applicationModel = this.props.ApplicationModel;
		let textConfig = applicationModel.text;
		let region = this.props.ApplicationModel.currentRegion;
		let windowSizes = this.props.ApplicationModel.windowSizeModel.windowSizes;

		let imageHeroBannerSvg = {
			lg: replaceStaticHost(images.heroBannerSvgLg),
			md: replaceStaticHost(images.heroBannerSvgMd),
			sm: replaceStaticHost(images.heroBannerSvgSm),
			xs: replaceStaticHost(images.heroBannerSvgXs),
		};

		let middleComponent = (
			<AddressPopupHOC>
				<AddressSearchHomeContainerB
					withoutBorder={true}
					withoutContainer={true}
					withQuiz={true}
					defaultVariantDropdown={1}
					buttonName={textConfig.START_TENDER}
					shortButtonName={textConfig.TENDER}
					tender={true}
				/>
			</AddressPopupHOC>
		);

		let subheaderForFrame = `${textConfig.BUSINESS_SUBHEADER_PART_1} ${this.props.declinations.prepositional} ${textConfig.BUSINESS_SUBHEADER_PART_2} ${this.props.declinations.genitive}!`;

		let content = (
			<BannerFrame
				seoBlock={this.props.seoBlock}
				title={this.props.h1Banner}
				center={true}
				subheader={subheaderForFrame}
				heroVideoButton={textConfig.heroVideoButton}
				bottomComponent={middleComponent}
			/>
		);

		let BottomComponent = <BusinessBenefitsContainer />;
		return (
			<Banner
				heroInternet={textConfig.heroInternet}
				background={imageHeroBannerSvg}
				content={content}
				business={true}
				windowSizes={windowSizes}
				bottomComponent={BottomComponent}
			/>
		);
	}
}
